/* prettier-ignore */
/* eslint-disable */
// API URL constants - separated to avoid circular dependencies
// This is the risksystem-hg backend. It uses bottle.py.
export const BASE_URL = process.env.NODE_ENV === 'production'
? '/'
// : 'https://dev1.ucits.risksystem.com/';
// : 'https://dev2tom.risksystem.com/';
: 'https://dev2david.risksystem.com/';
// : 'https://dev2darrach.risksystem.com/';
// : 'https://dev2lavy.risksystem.com/';
// : 'https://dev2han.risksystem.com/';
// : 'https://dev2jkeogh.risksystem.com/';
// : 'https://dev2sean.risksystem.com/';
// : 'https://dev2felix.risksystem.com/';
// : 'https://dev2zoe.risksystem.com/'
// : 'http://dev2sean/';
// : 'http://dev2felix/';
// : 'http://dev2david/';
// : 'http://10.2.26.3:8080/';

/* prettier-ignore */
/* eslint-disable */

// This is the risksystem3-public backend. It uses fastapi.
export const FAST_API_URL = process.env.NODE_ENV === 'production'
  ? '/public/api'
  : 'http://10.3.35.5/public/api'; // dev1fastapi
// : 'http://10.2.64.2:1080/api'; // tw1a
// : 'http://10.2.60.5:1080/api'; // db1

/* prettier-ignore */
/* eslint-disable */

// This variable doesnt work as intended.
export const PDF_GENERATOR_BASE_URL = process.env.NODE_ENV === 'production'
  ? 'risksystem_pdf_generator'
  : 'risksystem_pdf_generator';
// : 'http://0.0.0.0:8001/api'; // local

export const KID_PDF_GENERATOR_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'risksystem_pdf_generator_v2'
    : 'risksystem_pdf_generator_v2';
// : 'http://localhost:8001/api'; // local
